import React,{useEffect,useState} from 'react';
import { Carousel, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from "react-router-dom";

export const Home = () => {

  const location = useLocation();

   // const phoneNumber = location.state.phoneNumber;

  return (
    <>

    <section>
      <div className="main_wrap">
        
      <img
              className="d-block w-100"
              src={'/img/slide1.jpg'}
              alt="Slide 1"
            />
        <hr />

   <Container fluid className="text-center maincati">
          <h1 className="IRANSans_Medium">دسته بندی ها</h1>
          <div className="row justify-content-lg-center">
          <div className="col-lg-2 col-sm-4 col-6">
              <div className="bg-cati mb-3 categorize-text">
                <Link to={"/OnlineNobat"}>
                  <img
                    src={'/img/icons/medical.png'}
                    className="img-fluid"
                    style={{cursor:'pointer'}}
                    alt="نوبت دهی آنلاین"
                  />
                  </Link>
                  <h2>نوبت دهی آنلاین</h2>
              </div>
            </div>
            <div className="col-lg-2 col-sm-4 col-6">
              <div className="bg-cati mb-3 categorize-text">
                  <img
                    src={'/img/icons/optometry.png'}
                    className="img-fluid"
                    alt="مشاوره چشم پزشک"
                  />
                  <h2>مشاوره چشم پزشک</h2>
           
              </div>
            </div>
            <div className="col-lg-2 col-sm-4 col-6">
              <div className="bg-cati mb-3 categorize-text">
                  <img
                    src={'/img/icons/removeGlasses.png'}
                    className="img-fluid"
                    alt="روده و گوارش"
                  />
                  <h2>نوبت عمل چشم</h2>
              </div>
            </div>
            <div className="col-lg-2 col-sm-4 col-6">
              <div className="bg-cati mb-3 categorize-text">

                  <img
                    src={'/img/icons/2371318.png'}
                    className="img-fluid"
                    alt="سایر دسته ها"
                  />
                  <h2>مشاوره </h2>

              </div>
            </div>
          </div>
        </Container>
        <hr />
      </div>
    </section>
    </>
  );
};
